// [[Routing]] #obsidian-marker
export const workspacePaths = { analysis: "/analysis", catalog: "/catalog", bom: "/bom", analytics: "/analytics" };
export function workspaceTab(location) {
    if (location.pathname === "/catalog/categories") return "catalog";
    const matched = Object.keys(workspacePaths).find(key => workspacePaths[key] === location.pathname);
    if (matched) return matched;
    const params = new URLSearchParams(location.search);
    if (params.has("part") || params.has("productId") || ["catalog", "catalog-search"].includes(params.get("tab"))) return "catalog";
    return Object.hasOwn(workspacePaths, params.get("tab")) ? params.get("tab") : "analysis";
}
